import React from 'react'
import logo from './assets/custom.webp'
import { SIN } from './sign_in.styled'
import Form from 'react-bootstrap/Form'
import Alert from 'react-bootstrap/Alert'
import { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import { Link, useNavigate } from 'react-router-dom'
import { postRequest } from '../http'
import { z, ZodError } from 'zod'

  

export default function SignIn() {
  
    const [show, setShow] = useState(false);
    const [pass, setPass] = useState('')
    const [email, setEmail] = useState('')
    const [response, setResponse] = useState('')
    const [errors, setErrors] = useState('')
    const navigate = useNavigate()
    
    const onLogIn = async ()=> {
      const authValidate = z.object({
        email: z.string().email(),
        pass: z.string().min(2,{message: 'Password is required'})
      })

      try {
        
        const auth = {
          email: email, pass: pass
        }
        authValidate.parse(auth)
        postRequest('/sign-in', auth,(res)=>{
           console.log(res.data)
           if (res.data.success) {
            navigate('/admin')
           }else{

            setShow(true)
            setResponse(res.data.message)
           }
        })
      } catch (error) {
        if (error instanceof ZodError) {
          setErrors(error.flatten().fieldErrors)
        }else{
          setResponse(error.message)
        }
        
      }
      
    }
    
  return (
    <div>
    <SIN>
    
      <div className="form-head">
        <div>
        <img src={logo} height={'100px'} alt="" />
        <h3>Sign In</h3>
        </div>
      </div>
      <div className="al-wrap">
      {show && <Alert className='alert' variant="danger" onClose={() => setShow(false)} dismissible>
       
        <p>
        {response}
        </p>
      </Alert>}
      </div>
      <div className="form-wrap">
      <div className="form">
        <div>
        <Form.Label>Email</Form.Label>
        <Form.Control
        type='text'
        onChange={(e)=>setEmail(e.target.value)}
        value={email}
        ></Form.Control>
        </div>
        <div>
        <Form.Label>Password</Form.Label>
        <Form.Control
        type='password'
        onChange={(e)=>setPass(e.target.value)}
        value={pass}
        ></Form.Control>
        <Link id='reset' to=''>forget password?</Link>
        </div>
      </div>
      </div>
      <div className="in-btns">
        <div>
        <Button onClick={onLogIn} variant='primary'><Spinner as={'span'} animation="grow" size="sm" />Log In</Button></div>
        <Link to='/sign-up'>Dont have an account? Sign Up</Link>
      </div>
    </SIN>
    </div>
  )
}
